module.exports = __webpack_public_path__ + "static/assets/3efbbb96b14423a03bfe0fc0a5d4e461.png";